<template>
  <div class="home">
    <!-- 顶部信息导航 -->
    <div class="nav-top clearfix">
      <div class="clearfix nav-logo fl">
        <div class="logo fl">
          <img class="img-scale" src="../assets/images/logo.png" alt="" />
        </div>
        <div class="company fl">广东海川机器人<em style="font-size: 14px">工业物联网</em></div>
      </div>
      <div class="fr critical">
        <div
          class="item fl clearfix"
          v-for="(iten, index) in navCritical"
          :key="index"
        >
          <!-- <el-badge type="danger" :max="99" :value="iten.quantity">
            <i :class="iten.iocn" class="iocn fl"></i>
            <div class="authName fl">
              {{ iten.authName }}
            </div>
          </el-badge> -->
        </div>
        <div class="manage fl clearfix">
          <div class="head fl">
<!--            <el-avatar-->
<!--              src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"-->
<!--            >-->
<!--            </el-avatar>-->
          </div>
          <div class="user fl">{{meisuUserName}}</div>
          <div class="secede fl" @click="Quit">{{meisuUserName === '未登录'?'登录':'退出'}}</div>
        </div>
      </div>
      <!-- 顶部信息导航end -->
    </div>
    <div class="clearfix main">
      <!-- 左边导航栏 -->
      <div class="fl " :class="mastery ? 'nav-main' : 'nav-main-active'">
        <div class="pack">
          <i
            class="iconfont "
            :class="mastery ? 'icon-caidan-zhankai' : 'icon-caidan-shouqi'"
            @click="Control"
          >
          </i>
        </div>
        <el-menu
          :unique-opened="true"
          :router="true"
          :collapse="mastery"
          class="vertical"
          default-active="110"
        >
          <el-submenu
            v-for="item in navigation"
            :key="item.id"
            :index="String(item.id)"
          >
            <template slot="title">
              <i class="fa icon-bar icon-box" :class="item.icon"></i>
              <span slot="title">{{ item.authName }}</span>
            </template>
            <el-menu-item
              :route="{ name: tab.name }"
              v-for="tab in item.children"
              :key="tab.id"
              :index="String(tab.id)"
            >
              <template slot="title">
                <i class="fa icon-bar" :class="tab.icon"></i>
                <span slot="title">{{ tab.authName }}</span>
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div
        class="fl "
        :class="mastery ? 'content-main' : 'content-main-active'"
      >
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
// 引入样式
import "@/assets/font/iconfont.css";
export default {
  data() {
    return {
      navCritical: [
        {
          authName: "信息",
          iocn: "el-icon-message",
          quantity: "1",
        },
      ],
      isCollapse: true,
      navigation: [],
      navigationList: [
        {
          id: 101,
          authName: "实时监控",
          path: "",
          name: "TrueTime",
          icon: "fa-desktop",
          pid: 0,
          children: [
            {
              id: 110,
              authName: "生产监控01",
              path: "monitoing",
              name: "Monitoing",
              icon: "fa-area-chart",
              pid: 101,
            },
            {
              id: 111,
              authName: "生产监控02",
              path: "monitoingtwo",
              name: "MonitoingTwo",
              icon: "fa-area-chart",
              pid: 101,
            },
          ],
        },
        {
          id: 103,
          authName: "排产统计",
          name: "Statistics",
          path: "",
          icon: "el-icon-s-data",
          pid: 0,
          children: [
            {
              id: 201,
              authName: "日排产统计",
              path: "daytotal",
              name: "DayStatistics",
              icon: "el-icon-document-copy",
              pid: 210,
            },
            {
              id: 202,
              authName: "月排产统计",
              path: "monthtotal",
              name: "MonthStatistics",
              icon: "el-icon-document-copy",
              pid: 210,
            },
            {
              id: 203,
              authName: "年排产统计",
              path: "yeartotal",
              name: "YearStatistics",
              icon: "el-icon-document-copy",
              pid: 210,
            },
          ],
        },
        {
          id: 104,
          authName: "生产计划",
          name: "Promote",
          path: "",
          icon: "fa-calendar-check-o",
          pid: 0,
          children: [
            {
              id: 113,
              authName: "计划安排",
              path: "arrange",
              name: "Arrange",
              icon: "fa-clipboard",
              pid: 103,
            },
            {
              id: 114,
              authName: "计划详情",
              path: "calendar",
              name: "Calendar",
              icon: "fa-file-text-o",
              pid: 103,
            },
             {
              id: 115,
              authName: "排产管理",
              path: "adminplan",
              name: "adminplan",
              icon: "el-icon-folder-remove",
              pid: 103,
            },
          ],
        },

        {
          id: 105,
          authName: "用户管理",
          name: "Manage",
          path: "",
          pid: 0,
          icon: "fa-users",
          children: [
            {
              id: 118,
              authName: "用户列表",
              path: "user",
              name: "User",
              pid: 105,
              icon: "fa-user-circle-o",
            },
            {
              id: 119,
              authName: "权限管理",
              path: "rights",
              name: "Rights",
              pid: 105,
              icon: "fa-sitemap",
            },
            {
              id: 132,
              authName: "清除缓存",
              path: "delCache",
              name: "DelCache",
              pid: 106,
              icon: "el-icon-s-open",
            },
          ],
        },

      ],
      afold: false,
      mastery: false,
      meisuUserName: '', // 用户名
    };
  },
  created() {
    this.meisuUserName = localStorage.getItem('meisuUserName') || '未登录'; // 读取用户名
    // 向后端请求获取用户权限
    this.rightsMenus();
  },
  methods: {
    // 退出功能
    Quit() {
      this.$router.push({ name: "Login" });
      localStorage.setItem("meisutoken", "");
      localStorage.setItem("meisuUserName", "");
    },
    // 展开和收起
    Control() {
      if (this.mastery == true) {
        this.mastery = false;
      } else {
        this.mastery = true;
      }
    },
    handleOpen(key, keyPath) {
      
    },
    handleClose(key, keyPath) {
      
    },

    // 权限菜单
    rightsMenus(){
      let numTimes = localStorage.getItem('numTimes');
      if(Number(numTimes) === 1) return this.navigationList.map((e)=>{this.navigation.push(e)});
      this.axios.get(`/users/${numTimes}/rights`).then((res) => {
        if(res.data.data.length > 0){
          ["实时监控", "排产统计", "生产计划", "用户管理"].map((e, index)=>{
            for(let i=0;i<res.data.data.length;i++){
              if(e===res.data.data[i].name){
                this.navigation.push(this.navigationList[index]);
                break;
              }
            }
          });
        }else{
          this.navigation.push(this.navigationList[0]);
        }
      }).catch((err) => {
        this.navigation.push(this.navigationList[0]);
      });
    }
  },
};
</script>
<style lang="less" scoped>
@import "../assets/css/home.less";
</style>
